import { render } from "./filter-facet.vue?vue&type=template&id=604f99c7"
import script from "./filter-facet.vue?vue&type=script&lang=js"
export * from "./filter-facet.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__